import { message, Upload } from "antd";
import { allowedUploadTypes } from "../types/allowedAttachedDocuments.type";
import { RcFile, UploadFile } from "antd/es/upload";
import { allowedUploadFileTypesMessage } from "./acceptUploadFileTypes";

export const beforeUpload = (file: RcFile) => {
  if (file.size >= 1024 * 1024 * 10) {
    message.error(`${file.name} is too big, max file size is 10 MB`);
    return Upload.LIST_IGNORE;
  }
  if (!allowedUploadTypes.find((type) => type === file.type)) {
    message.error(` 
      Wrong ${file.name} extension.
      Allowed extensions: ${allowedUploadFileTypesMessage}
    `);
    return Upload.LIST_IGNORE;
  }
  return true;
};

export const getUniqueFileName = (
  file: RcFile,
  existingFiles: UploadFile[]
): RcFile => {
  const existingNames = existingFiles.map((f) => f.name);

  if (!existingNames.includes(file.name)) {
    return file; // no duplicate
  }

  // ✅ Lấy extension đúng cách
  const dotIndex = file.name.lastIndexOf(".");
  let base = file.name;
  let ext = "";

  if (dotIndex > 0) {
    base = file.name.substring(0, dotIndex);
    ext = file.name.substring(dotIndex); // giữ cả dấu chấm
  }

  // ✅ Sinh tên mới
  let counter = 1;
  let newName = `${base}(${counter})${ext}`;
  while (existingNames.includes(newName)) {
    counter++;
    newName = `${base}(${counter})${ext}`;
  }

  // ✅ Tạo RcFile mới với tên đã chỉnh
  const newFile = new File([file], newName, { type: file.type }) as RcFile;
  newFile.uid = file.uid;
  // lastModifiedDate is a read-only property, so we cannot assign it directly.
  // If you need lastModifiedDate, you can use the lastModified property when creating the File:
  Object.defineProperty(newFile, "lastModifiedDate", {
    get() {
      return file.lastModifiedDate;
    },
    configurable: true,
  });
  return newFile;
};
